import { styled } from '@mui/material';
import {
  createIncomeOrExpenseEditRoute,
  createLpInvestmentEditRoute,
} from 'adminConstants/routes';
import { ActionRef } from 'further-types/lp/action';
import { ActionRefLabels } from 'further-ui/labels';

const StyledLink = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'none',
  cursor: 'pointer',
}));

type Props = {
  id: string;
  actionRef: ActionRef;
};

const ActionLink: React.FC<Props> = ({ id, actionRef }) => {
  const link =
    actionRef === ActionRef.IncomeOrExpense
      ? createIncomeOrExpenseEditRoute(id)
      : actionRef === ActionRef.Investment
      ? createLpInvestmentEditRoute(id)
      : null;

  const actionLabel = ActionRefLabels[actionRef] ?? 'Unknown action type';
  return link ? (
    <StyledLink href={link} target="_blank">
      {actionLabel}
    </StyledLink>
  ) : (
    <span>{actionLabel}</span>
  );
};

export default ActionLink;
